var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"del"},[_c('ul',[_c('li',[_vm._v("确认删除该评论？")]),_c('li',{on:{"click":_vm.del}},[_vm._v("确认删除")]),_c('li',{on:{"click":_vm.cancel}},[_vm._v("取消")])])])}
var staticRenderFns = []

export { render, staticRenderFns }